import { useState } from "react";
import { Link } from "react-router-dom";
import { getVideosByType } from "@/utils/video";
import { formatRating, formatViews } from "@/utils/format";

const tabs = [
  { type: "movie", label: "电影", icon: "ri-film-line" },
  { type: "tv", label: "电视剧", icon: "ri-live-line" },
  { type: "variety", label: "综艺", icon: "ri-mic-line" },
];

export default function HotColumns() {
  const [active, setActive] = useState("movie");
  const list = [...getVideosByType(active)].sort((a, b) => b.views - a.views);
  const hero = list[0];
  const rest = list.slice(1);

  return (
    <section className="px-4 md:px-8 py-10 md:py-14 bg-background-100/60">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6 md:mb-8">
        <div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">热门栏目</h2>
          <p className="mt-1.5 text-sm text-foreground-600">按播放热度实时排序，发现正在被追的精彩内容</p>
        </div>
        <div className="flex items-center gap-1 p-1 rounded-full bg-background-200/70 self-start">
          {tabs.map((tab) => (
            <button
              key={tab.type}
              type="button"
              onClick={() => setActive(tab.type)}
              className={`px-4 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                active === tab.type
                  ? "bg-accent-500 text-background-50"
                  : "text-foreground-700 hover:text-foreground-950"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
        {hero && (
          <Link
            to={`/detail/${hero.id}`}
            className="group relative rounded-lg overflow-hidden min-h-[280px] lg:min-h-[420px] cursor-pointer"
          >
            <img
              src={hero.poster}
              alt={`${hero.title}海报`}
              title={`${hero.title} - ${hero.genres.join(" ")}`}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/40 to-transparent" />
            <div className="absolute top-4 left-4 flex items-center gap-2">
              <span className="px-3 py-1 rounded-md text-xs font-bold bg-accent-500 text-background-50">NO.1</span>
              <span className="px-2.5 py-1 rounded-md text-xs font-medium bg-background-50/80 text-foreground-900">
                {hero.typeLabel}
              </span>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">{hero.title}</h3>
              <div className="flex flex-wrap items-center gap-3 mt-2 text-sm text-foreground-700">
                <span className="flex items-center gap-1 font-semibold text-accent-500">
                  <i className="ri-star-fill" /> {formatRating(hero.rating)}
                </span>
                <span>{hero.year}</span>
                <span>{hero.region}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-fire-line" /> {formatViews(hero.views)} 播放
                </span>
              </div>
              <p className="mt-2 text-sm text-foreground-600 line-clamp-2 max-w-lg">{hero.summary}</p>
            </div>
          </Link>
        )}

        <ol className="flex flex-col gap-2">
          {rest.map((video, i) => (
            <li key={video.id}>
              <Link
                to={`/detail/${video.id}`}
                className="group flex items-center gap-4 p-2.5 rounded-lg hover:bg-background-200/60 transition-colors cursor-pointer"
              >
                <span
                  className={`w-8 text-center shrink-0 font-heading font-extrabold text-lg ${
                    i < 2 ? "text-accent-500" : "text-foreground-500"
                  }`}
                >
                  {i + 2}
                </span>
                <img
                  src={video.poster}
                  alt={`${video.title}海报`}
                  title={video.title}
                  className="w-14 h-20 shrink-0 object-cover object-top rounded-md"
                />
                <span className="min-w-0 flex-1">
                  <span className="block font-medium text-foreground-950 truncate group-hover:text-accent-500 transition-colors">
                    {video.title}
                  </span>
                  <span className="block mt-1 text-xs text-foreground-500">
                    {video.year} · {video.region} · {video.genres.slice(0, 2).join("/")}
                  </span>
                  <span className="mt-1 flex items-center gap-3 text-xs text-foreground-600">
                    <span className="flex items-center gap-1">
                      <i className="ri-star-fill text-accent-500" /> {formatRating(video.rating)}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line" /> {formatViews(video.views)}
                    </span>
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}